import { render, staticRenderFns } from "./VersionDisplay.vue?vue&type=template&id=98679f8c&scoped=true&"
import script from "./VersionDisplay.vue?vue&type=script&lang=js&"
export * from "./VersionDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98679f8c",
  null
  
)

export default component.exports